import React from 'react';

export const InfoProLogo = () => {
    return (<h3 className={'infopro_logo text-uppercase'}>Info<span className={'square'}>Pro</span></h3>)
};
